class AlertController {
  constructor($scope, $timeout) {
    var self = this;
    self.$scope = $scope;
    self.$timeout = $timeout;
    self.alerts = [];

    self.$scope.$on('alert', function(event, alert){
      self.alerts.push(alert);
      self.$timeout(function(){
        self.close(alert.id)
      }, 5000);
    });
  }

  close(alertId) {
    var self = this;
    for(var i=0; i<self.alerts.length; i++) {
      if(self.alerts[i].id === alertId) {
        self.alerts.splice(i, 1);
      }
    }
  }
}
AlertController.$inject = ['$scope', '$timeout'];
export default AlertController;
